<template>
  <div class="about CommonContentSingle-white">
    <User_personal />
  </div>
</template>
<script>
import User_personalinformation from './User_personalinformation'
import User_personal from './User_personal'
import User_modify from './User_modify'
export default {
  data() {
    return {
      activeName: 'first',
      pd: true,
    }
  },
  components: {
    User_personalinformation,
    User_personal,
    User_modify,
  },
  methods: {
    handleClick(tab, event) {},
  },
  mounted() {
    if (sessionStorage.getItem('entity') == '来访者') {
      this.pd = false
      this.activeName = 'second'
    } else {
      this.pd = true
    }
  },
}
</script>
<style scoped>
.about >>> .el-tabs--top {
  height: 100%;
}
.about >>> .el-tabs__content {
  height: calc(100% - 40px);
  overflow-y: auto;
}
</style>
